import { StyleSheet } from 'aphrodite';
import { brandPrimary, destructive, inputBorderColor, titles, white } from '../../styles/colors';
import { shadowSm } from '../../styles/shadows';

export const s = StyleSheet.create({
	inputGroup: {
		boxSizing: 'border-box',
		background: white,
		border: `1px solid ${inputBorderColor}`,
		position: 'relative',
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		'--input-group-border-radius': 8,
		borderRadius: 'var(--input-group-border-radius)',
		boxShadow: shadowSm,
		transition: 'color, box-shadow',
		outline: 'none',
		height: 36,
		minWidth: 0,
		'--input-group-addon-opacity': 1,
		':is([data-disabled])': {
			'--input-group-addon-opacity': 0.5,
		},
		'--input-group-addon-block-padding': 12,
		':has(> input)': {
			'--input-group-addon-block-padding': 10,
		},
		':has(> textarea)': {
			height: 'auto',
		},
		':has(> [data-align="inlineStart"]) > input': {
			paddingLeft: 8,
		},
		':has(> [data-align="inlineEnd"]) > input': {
			paddingRight: 8,
		},
		':has(> [data-align="blockStart"])': {
			height: 'auto',
			flexDirection: 'column',
		},
		':has(> [data-align="blockStart"]) > input': {
			paddingBottom: 12,
		},
		':has(> [data-align="blockEnd"])': {
			height: 'auto',
			flexDirection: 'column',
		},
		':has(> [data-align="blockEnd"]) > input': {
			paddingTop: 12,
		},
		':has([data-slot="input-group-control"]:focus-visible)': {
			borderColor: brandPrimary,
		},
		':has([data-slot][aria-invalid="true"])': {
			borderColor: destructive,
		},
	},
	inputGroupAddon: {
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		height: 'auto',
		cursor: 'text',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 8,
		paddingTop: 6,
		paddingBottom: 6,
		fontSize: 14,
		fontWeight: 600,
		lineHeight: '1.25rem',
		select: 'none',
		// @ts-ignore
		opacity: 'var(--input-group-addon-opacity)',
		':has(*) svg': {
			width: 16,
			height: 16,
			//color: `${titles}96`,
		},
	},
	inputGroupAddoninlineStart: {
		order: -9999,
		paddingLeft: 12,
		':has(>button)': {
			marginLeft: '-7.2px',
		},
	},
	inputGroupAddoninlineEnd: {
		order: 9999,
		paddingRight: 12,
		':has(>button)': {
			marginRight: '-7.2px',
		},
	},
	inputGroupAddonblockStart: {
		order: -9999,
		width: '100%',
		justifyContent: 'flex-start',
		paddingLeft: 12,
		paddingRight: 12,
		paddingTop: 'var(--input-group-addon-block-padding)',
	},
	inputGroupAddonblockEnd: {
		order: 9999,
		width: '100%',
		justifyContent: 'flex-start',
		paddingLeft: 12,
		paddingRight: 12,
		paddingBottom: 'var(--input-group-addon-block-padding)',
	},
	inputGroupButton: {
		boxSizing: 'border-box',
		fontSize: 14,
		boxShadow: 'none',
		display: 'flex',
		gap: 8,
		alignItems: 'center',
	},
	inputGroupButtonxs: {
		height: 24,
		gap: 4,
		paddingLeft: 8,
		paddingRight: 8,
		borderRadius: 'calc(var(--input-group-border-radius) - 5px)',
		':has(*) > svg': {
			width: 14,
			height: 14,
		},
		':has(> svg)': {
			paddingLeft: 8,
			paddingRight: 8,
		},
	},
	inputGroupButtonsm: {
		height: 32,
		gap: 6,
		paddingLeft: 10,
		paddingRight: 10,
		borderRadius: 6,
		':has(> svg)': {
			paddingLeft: 10,
			paddingRight: 10,
		},
	},
	inputGroupButtoniconXs: {
		width: 24,
		height: 24,
		borderRadius: 'calc(var(--input-group-border-radius) - 5px)',
		padding: 0,
		':has(>svg)': {
			padding: 0,
		},
	},
	inputGroupButtoniconSm: {
		width: 32,
		height: 32,
		padding: 0,
		':has(>svg) ': {
			padding: 0,
		},
	},
	inputGroupText: {
		color: titles,
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		fontSize: 14,
		lineHeight: '1.25rem',
		':has(*) svg': {
			pointerEvents: 'none',
			width: 16,
			height: 16,
		},
	},
	inputGroupInput: {
		flex: 1,
		borderRadius: 0,
		border: 'none',
		background: 'transparent',
		boxShadow: 'none',
		':focus-visible': {
			border: 'none',
		},
	},
	inputGroupTextarea: {
		flex: 1,
		resize: 'none',
		borderRadius: 0,
		border: 'none',
		background: 'transparent',
		paddingTop: 12,
		paddingBottom: 12,
		boxShadow: 'none',
		':focus-visible': {
			border: 'none',
		},
	},
});
